<div id="main-content">

    <!-- Breadcrumb on the left -->
    <nav aria-label="breadcrumb" class="px-5 mb-0">
      <ol class="breadcrumb mb-0">
        <li class="breadcrumb-item"><a [routerLink]="['/home']">Workspaces</a></li>
        <li class="breadcrumb-item"><a [routerLink]="newUrl">Visual</a></li>
        <li class="breadcrumb-item active" aria-current="page">Report</li>
      </ol>
    </nav>
  
    <!-- Centered text -->
    <div class="flex-grow-1 d-flex justify-content-center">
      <p class="fs-5 mb-4 text-center">Report Information</p>
    </div>


  <div class="d-flex flex-column align-items-center">
  <div class="card" style="max-width: 50%; width: 100%;" *ngIf="report; else noReport">
    <div class="card-body">
      <!-- Report Details -->
      <ul class="list-group mb-3">
        <li class="list-group-item">
          <strong>Display Name:</strong> {{ report.displayName }}
        </li>
        <li class="list-group-item">
          <strong>Report Type:</strong> {{ report.reportType }}
        </li>
        <li class="list-group-item">
          <strong>Is from Pbix:</strong> {{ report.isFromPbix }}
        </li>
        <li class="list-group-item">
          <strong>Is owned by me:</strong> {{ report.isOwnedByMe }}
        </li>
      </ul>

      <!-- Button to go to the report -->
      <div class="text-center">
        <a href="{{ report.webUrl }}" class="btn btn-primary" target="_blank" rel="noopener">
          <i class="fas fa-external-link-alt"></i> Go to Report <i class="bi bi-link"></i>
        </a>
      </div>
    </div>
  </div>
</div>
</div>

<!-- Fallback content if report is not available -->
<ng-template #noReport>
  <div class="alert alert-warning text-center" style="max-width: 600px; margin: 0 auto;">
    No report available.
  </div>
</ng-template>
